<ng-container *transloco="let convert;">
  <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
    <app-modal [modalId]="id">
      <div class="modal-close-container text-end">
        <button
          id="multi-error-close"
          class="modal__close"
          aria-label="Close modal"
          (click)="close()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
      <header class="modal__header mb-4 d-block">
        @if (modalHeaderText) {
          <h4 class="modal__title mb-0 fw-bold" tabindex="-1">
            {{convert('sellModule.posting.multiErrorModal.' + modalHeaderText)}}
          </h4>
        }
      </header>
      <div class="modal__content mt-2 text-start">
        @if (errorList?.length) {
          <div class="error-list-container mb-4">
            @for (error of errorList; track error) {
              <div class="error-item d-flex mb-3"
                >
                @if (modalHeaderText === 'nonIgnorableErrorModalheaderText') {
                  <div class="error-icon me-2">
                    <img
                      class="image-exclamation"
                      src="../../../../../ui/assets/icons/exclamation.svg"
                      alt="error"
                      />
                  </div>
                }
                <div>
                  {{convert('sellModule.posting.multiErrorModal.' + error.errCode, error.parameters)}}
                </div>
              </div>
            }
          </div>
        }
        @if ((modalHeaderText === 'nonIgnorableErrorModalheaderText')) {
          <div class="row">
            <div class="col-12 col-md-3">
              <button class="btn btn-primary btn-block w-100" data-track-name="Close" (click)="close()" [attr.aria-label]="convert('common.btnClose')">
                {{convert('common.btnClose')}}
              </button>
            </div>
          </div>
        } @else {
          <div class="action-buttons">
            <button
              class="btn btn-primary"
              data-track-name="Yes, Continue"
              (click)="continuePostingVehicle()"
              [attr.aria-label]="convert('common.btnYesContinue')">
              {{convert('common.btnYesContinue')}}
            </button>
            <button
              class="btn btn-link"
              data-track-name="Cancel"
              (click)="close()"
              [attr.aria-label]="convert('common.btnCancel')">
              {{convert('common.btnCancel')}}
            </button>
          </div>
        }
      </div>
    </app-modal>
  </trap-focus>
</ng-container>
